<template>
  <div :class="classes()">
    <VueCountUp :delay="delay" :endVal="endVal" :options="options" @ready="onReady" />
  </div>
</template>

<script>
import VueCountUp from 'vue-countup-v2';

export default {
  name: 'CountUp',
  props: {
    end: Number,
    suffix: {
      type: String,
      default: '',
    },
  },
  components: {
    VueCountUp,
  },
  data() {
    return {
      delay: 0,
      endVal: this.end,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        prefix: '',
        suffix: this.suffix,
      },
      el: 'o-countUp',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  watch: {
    end: function () {
      this.endVal = this.end;
    },
  },
  methods: {
    onReady: function () {
      // instance.update(that.endVal + 100);
    },
  },
};
</script>
